export default "__VITE_ASSET__CMfAdc99__"